import { Action } from '@ngrx/store';
import { EntriesState } from '../../../../../core/features/store/base-feature-state';
import { AlertsActions } from '../actions';
import { AlertsActionTypes } from '../actions/alerts.action';
import { DismissalState } from '../alerts-state';

export const initialState: EntriesState<DismissalState> = {};

export function reducer(state = initialState, action: Action): EntriesState<DismissalState> {
  switch (action.type) {
    case AlertsActionTypes.DismissAlert: {
      const _action = <AlertsActions.DismissAlert>action;
      return {
        ...state,
        [_action.payload.type]: {
          dismissed: true,
          reappearable: _action.payload.reappearable,
          messageHash: _action.payload.messageHash,
        },
      };
    }
    case AlertsActionTypes.SetAlert: {
      const _action = <AlertsActions.SetAlert>action;
      return {
        ...state,
        [_action.payload.type]: {
          dismissed: _action.payload.dismissed,
          reappearable: _action.payload.reappearable,
          messageHash: _action.payload.messageHash,
        },
      };
    }
    case AlertsActionTypes.ClearAlert: {
      const _action = <AlertsActions.ClearAlert>action;
      return {
        ...state,
        [_action.payload.type]: undefined,
      };
    }
    case AlertsActionTypes.ClearAllAlerts: {
      return initialState;
    }
  }

  return state;
}
